import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ServiceCard } from '../components/ServiceCard';
import { ProcessStrip } from '../components/ProcessStrip';
import { ServicesAccordion } from '../components/ServicesAccordion';
import { TestimonialSlider } from '../components/TestimonialSlider';
import { CoverageStrip } from '../components/CoverageStrip';
import { StickyCTA } from '../components/StickyCTA';
import { Phone, CheckCircle, Clock, Shield, Users, MessageSquare } from 'lucide-react';
export const Home = () => {
  const services = [{
    title: 'Bronze – One-Year Repair Service (1 Appliance)',
    price: '£99',
    features: ['12 months of engineer callouts and diagnostics', 'Labour included; standard parts fitted when available', 'Quick booking and UK-based support'],
    imageUrl: 'https://images.unsplash.com/photo-1626806787461-102c1bfaaea1?w=800&h=600&fit=crop',
    imageAlt: "Engineer repairing washing machine in customer's kitchen – diagnostics & repair",
    stripeLink: 'https://buy.stripe.com/bJe9AVfqneZg3hK5kXbjW00'
  }, {
    title: 'Silver – One-Year Repair Service (TV + Set-Top Box)',
    price: '£120',
    features: ['Fast response for TV faults and connection issues', 'Engineer visits scheduled promptly', 'Friendly support every step of the way'],
    imageUrl: 'https://images.unsplash.com/photo-1593784991095-a205069470b6?w=800&h=600&fit=crop',
    imageAlt: "Engineer repairing television in customer's living room – diagnostics & repair",
    stripeLink: 'https://buy.stripe.com/7sY3cxfqn8AS05y6p1bjW01'
  }, {
    title: 'Gold – Two-Year Repair Service (1 Appliance)',
    price: '£150',
    features: ['Extended engineer support for one appliance', 'Diagnostics, repairs and standard parts (when available)', 'Priority booking for the full term'],
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gwBsoRmzDkfc3FNhoYqtAK/17._Washing_Machine.png',
    imageAlt: 'Customer calling for washing machine repair support – diagnostics & repair',
    stripeLink: 'https://buy.stripe.com/8x23cxba7g3kbOgbJlbjW02'
  }];
  return <div className="min-h-screen bg-slate-50" style={{
    width: '100%'
  }} data-id="element-427">
      <Header data-id="element-428" />
      <section className="bg-gradient-to-br from-blue-500 to-blue-700 text-white py-20" data-id="element-429">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-430">
          <div className="max-w-3xl" data-id="element-431">
            <h1 className="text-5xl md:text-6xl font-bold mb-6" data-id="element-432">
              Fast, Reliable Appliance Repairs Across the UK
            </h1>
            <p className="text-xl md:text-2xl mb-8 text-blue-50" data-id="element-433">
              Qualified engineers. Clear pricing. Quick bookings.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-434">
              <a href="tel:08000554969" className="inline-flex items-center justify-center space-x-2 bg-white text-blue-600 px-8 py-4 rounded-lg hover:bg-slate-100 transition-colors font-semibold text-lg" data-id="element-435">
                <Phone className="w-5 h-5" data-id="element-436" />
                <span data-id="element-437">Book a Repair</span>
              </a>
              <a href="tel:08000554969" className="inline-flex items-center justify-center space-x-2 bg-blue-600 text-white px-8 py-4 rounded-lg hover:bg-blue-700 transition-colors font-semibold text-lg border-2 border-white" data-id="element-438">
                <MessageSquare className="w-5 h-5" data-id="element-439" />
                <span data-id="element-440">Request a Callout</span>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className="py-16" data-id="element-441">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-442">
          <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-443">
            <h2 className="text-4xl font-bold text-slate-800 mb-6" data-id="element-444">
              Welcome to Taskpoint
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed" data-id="element-445">
              We keep essential household appliances running with professional
              repair and maintenance services. Expect honest pricing, friendly
              support and engineers who fix problems properly—first time.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-446">
            <div className="bg-white p-6 rounded-xl shadow-md text-center" data-id="element-447">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-448">
                <CheckCircle className="w-8 h-8 text-blue-600" data-id="element-449" />
              </div>
              <h3 className="font-semibold text-slate-800 mb-2" data-id="element-450">UK-Based</h3>
              <p className="text-slate-600 text-sm" data-id="element-451">
                Local engineers serving your area
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-md text-center" data-id="element-452">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-453">
                <Users className="w-8 h-8 text-blue-600" data-id="element-454" />
              </div>
              <h3 className="font-semibold text-slate-800 mb-2" data-id="element-455">
                Vetted Engineers
              </h3>
              <p className="text-slate-600 text-sm" data-id="element-456">
                Qualified and experienced professionals
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-md text-center" data-id="element-457">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-458">
                <Shield className="w-8 h-8 text-blue-600" data-id="element-459" />
              </div>
              <h3 className="font-semibold text-slate-800 mb-2" data-id="element-460">
                Clear Pricing
              </h3>
              <p className="text-slate-600 text-sm" data-id="element-461">
                No hidden fees or surprises
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-md text-center" data-id="element-462">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-463">
                <Clock className="w-8 h-8 text-blue-600" data-id="element-464" />
              </div>
              <h3 className="font-semibold text-slate-800 mb-2" data-id="element-465">
                Secure Payments
              </h3>
              <p className="text-slate-600 text-sm" data-id="element-466">
                Safe and encrypted transactions
              </p>
            </div>
          </div>
        </div>
      </section>
      <ProcessStrip data-id="element-467" />
      <section className="py-16 bg-white" data-id="element-468">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-469">
          <h2 className="text-4xl font-bold text-slate-800 text-center mb-12" data-id="element-470">
            Our Repair Services
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-471">
            {services.map((service, index) => <ServiceCard key={index} {...service} data-id="element-472" />)}
          </div>
        </div>
      </section>
      <ServicesAccordion data-id="element-473" />
      <TestimonialSlider data-id="element-474" />
      <CoverageStrip data-id="element-475" />
      <section className="py-16 bg-slate-100" data-id="element-476">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-477">
          <div className="max-w-3xl mx-auto text-center" data-id="element-478">
            <h2 className="text-4xl font-bold text-slate-800 mb-6" data-id="element-479">
              Care for the Essentials in Your Home
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed mb-8" data-id="element-480">
              At Taskpoint, we know how important your appliances are. Our
              experienced engineers provide dependable repairs and practical
              maintenance that keep your home running smoothly. We're
              transparent, polite and easy to reach—so you always know what to
              expect.
            </p>
            <div className="flex flex-wrap justify-center gap-6" data-id="element-481">
              <div className="flex items-center space-x-2 text-slate-700" data-id="element-482">
                <CheckCircle className="w-5 h-5 text-blue-600" data-id="element-483" />
                <span className="font-medium" data-id="element-484">UK-based</span>
              </div>
              <div className="flex items-center space-x-2 text-slate-700" data-id="element-485">
                <CheckCircle className="w-5 h-5 text-blue-600" data-id="element-486" />
                <span className="font-medium" data-id="element-487">Vetted Engineers</span>
              </div>
              <div className="flex items-center space-x-2 text-slate-700" data-id="element-488">
                <CheckCircle className="w-5 h-5 text-blue-600" data-id="element-489" />
                <span className="font-medium" data-id="element-490">Clear Pricing</span>
              </div>
              <div className="flex items-center space-x-2 text-slate-700" data-id="element-491">
                <CheckCircle className="w-5 h-5 text-blue-600" data-id="element-492" />
                <span className="font-medium" data-id="element-493">Secure Payments</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <StickyCTA data-id="element-494" />
      <Footer data-id="element-495" />
    </div>;
};